import { ModalBottom } from "../ModalBottom";
import { ReactComponent as IconCamera } from "../../../styles/assets/svg/icon_camera.svg";
import { ReactComponent as IconDietNote } from "../../../styles/assets/svg/icon_dietNote.svg";
import { useNavigate } from "react-router-dom";

interface ModalDietProps {
  setOpen: (e: any) => void;
  titleText: any;
  subtitleText: any;
  formattedDate: any;
}

const smallBadgeText = {
  fontSize: 12,
  fontWeight: 700,
  lineHeight: "16px",
  color: "#E66F00",
};

export const ModalDietNote = ({
  setOpen,
  titleText,
  subtitleText,
  formattedDate,
}: ModalDietProps) => {
  const navi = useNavigate();
  return (
    <ModalBottom
      title="어떻게 기록할까요?"
      onClose={() => setOpen(false)}
      onRow={false}
    >
      <div
        style={{
          padding: "0 16px 24px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <div
          style={{
            width: "100%",
            padding: 16,
            borderRadius: 16,
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "linear-gradient(180deg, #FFA040 0%, #F57C00 100%)",
            cursor: "pointer",
          }}
          onClick={() =>
            navi("/diet/write/AI", { state: { date: formattedDate } })
          }
        >
          <div
            style={{
              width: 48,
              height: 48,
              background: "#FFEEDA",
              borderRadius: 8,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IconCamera />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 4,
              }}
            >
              <div
                style={{ ...titleText, color: "var(--neutral-50, #FAFAFA)" }}
              >
                AI 분석
              </div>
              <div
                style={{
                  height: 18,
                  paddingLeft: 6,
                  paddingRight: 6,
                  paddingTop: 2,
                  paddingBottom: 2,
                  background: "#FFF8F1",
                  overflow: "hidden",
                  borderRadius: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 10,
                  display: "flex",
                }}
              >
                <div
                  style={{
                    ...smallBadgeText,
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  추천
                </div>
              </div>
            </div>
            <div
              style={{
                ...subtitleText,
                color: "var(--neutral-100, #F5F5F5)",
              }}
            >
              사진 한 장으로 3초만에 자동 분석!
            </div>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            height: 80,
            padding: 16,
            background: "var(--neutral-50, #FAFAFA)",
            borderRadius: 16,
            outline: "1px var(--neutral-200, #E5E5E5) solid",
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
          onClick={() =>
            navi("/diet/write", { state: { date: formattedDate } })
          }
        >
          <div
            style={{
              width: 48,
              height: 48,
              background: "var(--neutral-100, #F5F5F5)",
              borderRadius: 8,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IconDietNote />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <div style={{ ...titleText, color: "var(--neutral-600, #525252)" }}>
              직접 기록
            </div>
            <div style={subtitleText}>음식명을 검색하거나 직접 등록하기</div>
          </div>
        </div>
      </div>
    </ModalBottom>
  );
};
